import * as React from 'react';
import { ITable8Row } from './common';
import { sortBasedOnList } from '../utils';

export type Table8aData = { [key: string]: ITable8Row };
export interface ITable8aProps {
  data: Table8aData;
}

interface ITable8aState {
}

const sortOrder = [
  "DOT-Compliant Motorcycle Helmet",
  "Non DOT-Compliant Motorcycle Helmet",
  "Unknown If DOT-Compliant Motorcycle Helmet",
  "No Helmet",
  "Unknown",
];

export default class Table8a extends React.Component<ITable8aProps, ITable8aState> {
  constructor(props: ITable8aProps) {
    super(props);
    this.state = {
    };
  }

  componentDidMount = function () {
  }

  public render() {
    return (
      this.props.data ?
        <React.Fragment>
          <table className="ss-table summaryTable1">
            <colgroup>
              <col style={{ width: 368 }} />
            </colgroup>
            <thead>
              <tr>
                <th rowSpan={3} className="border-right-bold">
                  <div className="ss-table-header">
                    <span className="header-number">8a</span>
                    <span className="header-text">HELMET USE</span>
                  </div>
                </th>
                <th colSpan={8}>MOTORCYCLISTS AND PASSENGERS</th>
              </tr>
              <tr>
                <th rowSpan={2}>TOTAL</th>
                <th colSpan={3}>KILLED</th>
                <th colSpan={3}>INJURED</th>
                <th rowSpan={2}>NO INJURY</th>
              </tr>
              <tr>
                <th>TOTAL</th>
                <th>HEAD INJURY</th>
                <th>OTHER INJURY</th>
                <th>TOTAL</th>
                <th>HEAD INJURY</th>
                <th>OTHER INJURY</th>
              </tr>
            </thead>
            <tbody>
              {sortBasedOnList(this.props.data, sortOrder).map((key) =>
                <tr key={key}>
                  <td className="border-right-bold">{key}</td>
                  <td className="numberTotals">{this.props.data[key].total}</td>
                  <td className="numberTotals">{this.props.data[key].killedTotal}</td>
                  <td className="numberTotals">{this.props.data[key].killedHeadInjury}</td>
                  <td className="numberTotals">{this.props.data[key].killedOtherInjury}</td>
                  <td className="numberTotals">{this.props.data[key].injuredTotal}</td>
                  <td className="numberTotals">{this.props.data[key].injuredHeadInjury}</td>
                  <td className="numberTotals">{this.props.data[key].injuredOtherInjury}</td>
                  <td className="numberTotals">{this.props.data[key].noInjury}</td>
                </tr>
              )}
            </tbody>
          </table>
        </React.Fragment>
        : <p>Loading...</p>
    );
  }
}
